import { useEffect } from 'react'

/**
 * Loop Assist (Greystone Assist) chatbot loader — TOGGLEABLE paid add-on.
 *
 * Loads the embeddable widget ONLY when `VITE_ASSIST_API` is set at build time.
 * To turn the chatbot OFF for production: remove `VITE_ASSIST_API` from the build env
 * and redeploy — no code change. (See docs/SaaS/greystone/golive_plan.md.)
 *
 * Skips injection during the SSG prerender (Playwright sets `navigator.webdriver`), so
 * the widget is never baked into the static HTML — it initialises on real visits only.
 */
export default function AssistWidget() {
  useEffect(() => {
    const env = import.meta.env as unknown as Record<string, string | undefined>
    const api = env.VITE_ASSIST_API
    if (!api) return
    if (typeof navigator !== 'undefined' && navigator.webdriver) return // SSG prerender
    if (document.getElementById('loop-assist-embed')) return
    const s = document.createElement('script')
    s.id = 'loop-assist-embed'
    s.src = api.replace(/\/$/, '') + '/embed.js'
    s.async = true
    s.setAttribute('data-tenant', env.VITE_ASSIST_TENANT || 'greystone')
    s.setAttribute('data-api', api)
    document.body.appendChild(s)
  }, [])
  return null
}
